<template>
  <div>
    <v-card flat class="rounded-lg mt-5 textLight--text px-4 px-md-2">
      <v-row align="center" class="pa-3 pa-md-0">
        <v-col cols="1" class="text-start ps-md-7">
          <v-checkbox
            :input-value="isSelected"
            @change="$emit('onChange', $event)"
          />
        </v-col>

        <v-col cols="11" sm="5" md>
          <div class="text-ellipse-2 text-start">
            {{
              data.organizationDetails &&
              data.organizationDetails.organizationName
                ? getLocalisedValue(data.organizationDetails.organizationName)
                : "-"
            }}
          </div>
        </v-col>

        <v-col cols="12" sm="6" md>
          <div class="text-ellipse-2 text-start">
            {{ data.invoiceNo ? data.invoiceNo : "-" }}
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <div class="text-start text-md-center">
            <span>
              {{ invoiceQuantity != null ? invoiceQuantity : "-" }}
            </span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <div class="text-start">
            {{
              invoiceAmount != null
                ? `${currency} ${formatPrice(invoiceAmount)}`
                : "-"
            }}
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <div class="text-start">
            {{
              data.invoiceDate
                ? moment(parseInt(data.invoiceDate)).format("DD MMM YYYY")
                : "-"
            }}
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "InvoicesTableRow",
  props: {
    data: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      currency: this.data.currency ?? "",
    };
  },
  computed: {
    invoiceQuantity() {
      // return this.data.invoiceQuantity;
      return this.data.orderItems?.reduce((result, x) => {
        return result + x.quantity;
      }, 0);
    },
    invoiceAmount() {
      // return this.data.invoiceAmount;
      return this.data.orderItems?.reduce((result, x) => {
        return result + x.quantity * (x.unitPrice - x.discount);
      }, 0);
    },
  },
};
</script>
